 const { qiankuan } = require("../../config")

 /**
    * 路由监听
    * @param {*} routerPrefix 前缀
*/


function genActiveRule(routerPrefix) {
  const opt = location => location.pathname.startsWith(routerPrefix);
  return opt
}

const microApps = [
  {
    name: "subShop",
    entry: qiankuan.subShop.entry, // "http://localhost:5501",
    activeRule: '/sanyiusa/subShop/', // genActiveRule("/subShop"), // '#/subShop', // 
    container: "#subShop",
    props: {
      baseUrl: '/sanyiusa/subShop/',
      data: {
        msg: '来自基座的数据1'
       },
      fns: [
        function LOGOUT_(data) {
          // alert('父应用返回信息：' + data)
        }
      ]
    }
  }
];

const apps = configData => microApps.map((item) => {
  // item.props.ui = ui
   if(configData && Object.prototype.toString.call(configData) === "[object Object]") {
        for( const [key, value] of Object.entries(configData)) {
          if(item.props) {
            item.props[key] = value
          }
        }
    }
  
  return {
    ...item
  };
});
export default apps
